<template>
  <section>
    <h1 class="title is-4">Detalle planilla</h1>
    <h2 class="subtitle is-6 fontMono">
      <strong>{{ planilla.name }}</strong> {{ nmonth[planilla.month] }} de
      {{ planilla.year }}, periodicidad
      {{ nameperiodicity[planilla.periodicity] }}
    </h2>
    <div class="table-container">
      <table class="tablem">
        <tr class="has-background-light">
          <th class="celdaempleado">
            <center>
              Empleado
              <button
                class="
                  button
                  is-small is-light
                  tooltip
                  is-tooltip-right is-tooltip-link
                "
                data-tooltip="Crear empleado"
              >
                <span class="icon is-small">
                  <span class="material-icons has-text-link">
                    add_circle_outline
                  </span>
                </span>
              </button>
            </center>
          </th>
          <th class="celdadevengadodeduccion" style="width: 720px">
            <center>
              Devengados
              <button
                class="
                  button
                  is-small is-light
                  tooltip
                  is-tooltip-right is-tooltip-link
                "
                data-tooltip="Agregar devengado"
              >
                <span class="icon is-small">
                  <span class="material-icons has-text-link">
                    add_circle_outline
                  </span>
                </span>
              </button>
            </center>
          </th>
          <th class="celdadevengadodeduccion" style="width: 520px">
            <center>
              Deducciones
              <button
                class="
                  button
                  is-small is-light
                  tooltip
                  is-tooltip-right is-tooltip-link
                "
                data-tooltip="Agregar deducción"
              >
                <span class="icon is-small">
                  <span class="material-icons has-text-link">
                    add_circle_outline
                  </span>
                </span>
              </button>
            </center>
          </th>
          <th>
            <center>Total</center>
          </th>
        </tr>
      </table>
      <table class="tablen">
        <thead>
          <tr class="has-background-light" style="font-size: 13px">
            <th class="nombrecelda">Nombre</th>
            <th class="celdacien">Identificación</th>
            <th class="celdacien">Salario base</th>
            <th class="celdacien">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar devengado"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              Sal básico
            </th>
            <th class="celdacien">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar devengado"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              Aux Tte
            </th>
            <th class="celdacien">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar devengado"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              Vacaciones
            </th>
            <th class="celdacien">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar devengado"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              Prima
            </th>
            <th class="celdacien">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar devengado"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              Cesantías
            </th>
            <th class="celdacien">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar devengado"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              Int cesantías
            </th>
            <th class="celdacientoveinte">Total Devengado</th>
            <th class="celdacien">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar deducción"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              Salud
            </th>
            <th class="celdacien">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar deducción"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              Pensión
            </th>
            <th class="celdacien">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar deducción"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              F Solidaridad
            </th>
            <th class="celdacien">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar deducción"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              Retefuente
            </th>
            <th class="celdacientoveinte">Total deducciones</th>
            <th class="celdacientoveinte"><center>Devengado</center></th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in dataplanilla" :key="index">
          <tr class="fontMono" style="font-size: 13px">
            <td :class="celdactiva(index, 0)">
              <div class="contenedor">
                <div
                  class="closecolumn hand tooltip"
                  data-tooltip="Eliminar fila"
                >
                  <span class="material-icons" style="font-size: 14px">
                    highlight_off
                  </span>
                </div>
              </div>
              {{ item.empleado.name }}
            </td>
            <td :class="celdactiva(index, 1)">{{ item.empleado.codigo }}</td>
            <td class="has-text-right" :class="celdactiva(index, -17)">
              {{ item.empleado.salariobase | number(2) }}
            </td>
            <td class="has-text-right" :class="celdactiva(index, 2)">
              {{ item.devengados.salario | number(2) }}
            </td>
            <td class="has-text-right" :class="celdactiva(index, 3)">
              {{ item.devengados.auxtte | number(2) }}
            </td>
            <td class="has-text-right" :class="celdactiva(index, 4)">
              {{ item.devengados.vacaciones | number(2) }}
            </td>
            <td class="has-text-right" :class="celdactiva(index, 5)">
              {{ item.devengados.prima | number(2) }}
            </td>
            <td class="has-text-right" :class="celdactiva(index, 6)">
              {{ item.devengados.cesantias | number(2) }}
            </td>
            <td class="has-text-right" :class="celdactiva(index, 7)">
              {{ item.devengados.intcesantias | number(2) }}
            </td>
            <td
              class="has-text-right has-background-light"
              :class="celdactiva(index, -17)"
            >
              <strong>{{ item.devengados.total | number(2) }}</strong>
            </td>
            <td class="has-text-right" :class="celdactiva(index, 8)">
              {{ item.deducciones.salud | number(2) }}
            </td>
            <td class="has-text-right" :class="celdactiva(index, 9)">
              {{ item.deducciones.pension | number(2) }}
            </td>
            <td class="has-text-right" :class="celdactiva(index, 10)">
              {{ item.deducciones.solidaridad | number(2) }}
            </td>
            <td class="has-text-right" :class="celdactiva(index, 11)">
              {{ item.deducciones.retefuente | number(2) }}
            </td>
            <td
              class="has-text-right has-background-light"
              :class="celdactiva(index, -17)"
            >
              <strong>{{ item.deducciones.total | number(2) }}</strong>
            </td>
            <td
              class="has-text-right has-background-light"
              :class="celdactiva(index, -17)"
            >
              <strong class="has-text-link">{{
                item.devengado | number(2)
              }}</strong>
            </td>
          </tr>
          <tr class="has-background-light" v-if="fila === index">
            <td colspan="16">
              <div class="field has-addons">
                <div class="control">
                  <a class="button"
                    ><span class="icon is-medium">
                      <i class="material-icons">list_alt</i>
                    </span>
                  </a>
                </div>
                <div class="control">
                  <input
                    id="inputnomina"
                    @keydown="keyfunction($event)"
                    class="input"
                    type="text"
                    placeholder="Find a repository"
                  />
                </div>
                <div class="control">
                  <a class="button is-info"
                    ><span class="icon">
                      <i class="material-icons">done_outline</i>
                    </span></a
                  >
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      columna: 0,
      fila: 0,
      dataplanilla: [
        {
          empleado: {
            name: "Juan David Jaramillo",
            codigo: 98667796,
            salariobase: 990000000,
          },
          devengados: {
            salario: 3000000,
            auxtte: 200000,
            vacaciones: 200000,
            prima: 200000,
            cesantias: 200000,
            intcesantias: 200000,
            total: 4000000,
          },
          deducciones: {
            salud: 200000,
            pension: 200000,
            solidaridad: 200000,
            retefuente: 200000,
            total: 800000,
          },
          devengado: 3200000,
        },
        {
          empleado: {
            name: "Carolina Cardenas Hurtado",
            codigo: 1152695401,
            salariobase: 2000000,
          },
          devengados: {
            salario: 1000000,
            auxtte: 200000,
            vacaciones: 200000,
            prima: 200000,
            cesantias: 200000,
            intcesantias: 200000,
            total: 2000000,
          },
          deducciones: {
            salud: 200000,
            pension: 200000,
            solidaridad: 200000,
            retefuente: 200000,
            total: 800000,
          },
          devengado: 1200000,
        },
        {
          empleado: {
            name: "Carlos Andres Jaramillo",
            codigo: 8162046,
            salariobase: 2000000,
          },
          devengados: {
            salario: 1000000,
            auxtte: 200000,
            vacaciones: 200000,
            prima: 200000,
            cesantias: 200000,
            intcesantias: 200000,
            total: 2000000,
          },
          deducciones: {
            salud: 200000,
            pension: 200000,
            solidaridad: 200000,
            retefuente: 200000,
            total: 800000,
          },
          devengado: 1200000,
        },
                {
          empleado: {
            name: "Carlos Andres Jaramillo",
            codigo: 8162046,
            salariobase: 2000000,
          },
          devengados: {
            salario: 1000000,
            auxtte: 200000,
            vacaciones: 200000,
            prima: 200000,
            cesantias: 200000,
            intcesantias: 200000,
            total: 2000000,
          },
          deducciones: {
            salud: 200000,
            pension: 200000,
            solidaridad: 200000,
            retefuente: 200000,
            total: 800000,
          },
          devengado: 1200000,
        },
      ],
      planilla: {},
      nmonth: {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre",
      },
      nameperiodicity: {
        1: "Semanal",
        2: "Decanal",
        3: "Catorcenal",
        4: "Quincenal",
        5: "Mensual",
        6: "Otro",
      },
    };
  },
  methods: {
    keyfunction(e) {
      console.log("keycode", e.keyCode);
      if (e.keyCode === 39) {
        // presiona la tecla a la derecha
        e.preventDefault();
        this.columna++;
      }
      if (e.keyCode === 37) {
        e.preventDefault();
        this.columna--;
      }
      if (e.keyCode === 38) {
        e.preventDefault();
        this.fila--;
        setTimeout(function () {
          document.getElementById("inputnomina").focus();
        }, 5);
      }
      if (e.keyCode === 40) {
        e.preventDefault();
        this.fila++;
        setTimeout(function () {
          document.getElementById("inputnomina").focus();
        }, 5);
      }
    },
    celdactiva(f, c) {
      if (f === this.fila && c === this.columna) {
        return "celdactiva";
      } else {
        return "celdainactiva";
      }
    },
    async findplanilla() {
      try {
        const result = await apiServices.get(
          `/planilla/${this.$route.params.planillaid}`
        );
        if (result.data) {
          this.planilla = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.findplanilla();
  },
};
</script>

<style lang="scss">
.contenedor {
  position: relative;
}
.closecolumn {
  position: absolute;
  right: 0;
  margin-top: -3px;
  margin-right: -6px;
}
.tablen {
  table-layout: fixed;
  width: 1780px;
  th,
  td {
    padding: 6px;
  }
}
.tablem {
  table-layout: fixed;
  width: 1780px;
  th,
  td {
    padding: 6px;
    border-top: 1px solid #dbdbdb;
    border-left: 1px solid #dbdbdb;
    border-right: 1px solid #dbdbdb;
  }
}
.celdacientoveinte {
  width: 120px;
  word-wrap: break-word;
  border: 1px solid #dbdbdb;
}
.celdacien {
  width: 100px;
  word-wrap: break-word;
  border: 1px solid #dbdbdb;
}
.nombrecelda {
  width: 220px !important;
  word-wrap: break-word;
  border: 1px solid #dbdbdb;
}
.celdaempleado {
  width: 420px !important;
  word-wrap: break-word;
  border: 1px solid #dbdbdb;
}
.celdadevengadodeduccion {
  word-wrap: break-word;
  border: 1px solid #dbdbdb;
}
.celdactiva {
  border: 1px solid #dbdbdb !important;
  background-color: #3273dc;
  color: white;
}
.celdainactiva {
  border: 1px solid #dbdbdb;
}
</style>


// WEBPACK FOOTER //
// src/components/nomina/planilla/Detalleplanilla.vue